import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AttentionOffice } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectAttentionOffice = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {

    const { instance, lista, setLista } = useDataBean(_AttentionOffice)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: number) => {

        setID(e);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDAttentionOffice == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : e);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    const getLista = () => {
        instance.getAttentionOfficeCatalog(null).then(
            (resp: any) => {
                setLista(resp)
                console.log(resp)
            }
        ).catch(err => {
            setLista([]);
        });
    };


    return (
        <>
            <label>{label ?? "Tipos de Labor"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valie = e.target.value ? Number(e.target.value) : null;
                setValue(valie)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDAttentionOffice} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}